<template>
  <div class="faq-module">
    <div
      v-for="(item, index) in faqs"
      :key="index"
      class="faq-item"
      :class="{ active: activeIndex === index }"
    >
      <button
        type="button"
        class="faq-question"
        :aria-expanded="activeIndex === index"
        @click="toggleFaq(index)"
      >
        <span class="faq-num">{{ index + 1 }}</span>
        <span class="faq-text">{{ item.question }}</span>
        <span class="faq-chevron" :class="{ open: activeIndex === index }">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </button>
      <transition name="faq-slide">
        <div v-if="activeIndex === index" class="faq-answer-wrap">
          <div class="faq-answer" v-html="item.answer" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    faqs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: null,
    };
  },
  methods: {
    toggleFaq(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-module {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.faq-item {
  border-radius: 12px;
  border: 1px solid #e8f0ec;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.25s, box-shadow 0.25s;

  &:hover {
    border-color: #c8e6d5;
    box-shadow: 0 2px 12px rgba(18, 140, 126, 0.08);
  }

  &.active {
    border-color: #25D366;
    box-shadow: 0 4px 16px rgba(37, 211, 102, 0.12);

    .faq-question {
      background: linear-gradient(90deg, #f0faf4 0%, #fff 100%);
    }

    .faq-num {
      background: linear-gradient(135deg, #25D366, #128C7E);
      color: #fff;
    }

    .faq-chevron {
      background: #e9f7ef;
      color: #128C7E;
    }
  }
}

.faq-question {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 16px 18px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: background 0.25s;

  &:hover {
    background: #fafdfb;
  }
}

.faq-num {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #e9f7ef;
  color: #128C7E;
  font-size: 13px;
  font-weight: 700;
  transition: background 0.25s, color 0.25s;
}

.faq-text {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.45;
}

.faq-chevron {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f4f6f5;
  color: #666;
  transition: transform 0.3s ease, background 0.25s, color 0.25s;

  svg {
    width: 18px;
    height: 18px;
  }

  &.open {
    transform: rotate(180deg);
  }
}

.faq-answer-wrap {
  overflow: hidden;
}

.faq-answer {
  padding: 0 18px 18px 62px;
  font-size: 15px;
  line-height: 1.7;
  color: #555;

  ::v-deep a {
    color: #128C7E;
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover {
      color: #075E54;
    }
  }
}

// 展开动画
.faq-slide-enter-active,
.faq-slide-leave-active {
  transition: opacity 0.25s ease, max-height 0.3s ease;
  max-height: 300px;
}

.faq-slide-enter,
.faq-slide-leave-to {
  opacity: 0;
  max-height: 0;
}

@media (max-width: 600px) {
  .faq-question {
    padding: 14px;
    gap: 10px;
  }

  .faq-text {
    font-size: 14px;
  }

  .faq-answer {
    padding: 0 14px 14px 14px;
    font-size: 14px;
  }
}
</style>
